import { api } from 'app/config/apiConfig';
import { VerificationDocument, VerificationDocumentType } from '../model/types';

interface UploadArgs {
  userId: string;
  files: File[];
  documentTypes: VerificationDocumentType[];
}

export const getUserVerificationDocumentsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getUserVerificationDocuments: builder.query<VerificationDocument[], { userId: string }>({
      query: ({ userId }) => ({
        url: `/users/${userId}/verification-documents`,
        params: { latestOnly: true },
      }),
      providesTags: ['VerificationDocuments'],
    }),
    uploadVerificationDocument: builder.mutation<VerificationDocument, UploadArgs>({
      query: ({ userId, files, documentTypes }) => {
        const formData = new FormData();

        files.forEach((file) => {
          formData.append('files', file);
        });

        documentTypes.forEach((type) => {
          formData.append('documentTypes', type);
        });

        return {
          url: `/users/${userId}/verification-request`,
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: ['VerificationDocuments', 'Users'],
    }),
  }),
});

export const { useGetUserVerificationDocumentsQuery, useUploadVerificationDocumentMutation } = getUserVerificationDocumentsApi;
